export const osVersionOptions = ["windows11", "windows10", "ubuntu24.04", "ubuntu22.04","ubuntu20.04"];